export const Spinner = ({ label }: { label: string }) => (
  <span className="spinner" role="status" aria-label={label}>
    <span className="spinner-dot" aria-hidden="true" />
    {label}
  </span>
)
